import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { HiX, HiMenuAlt3 } from "react-icons/hi";
import { motion, AnimatePresence } from "framer-motion";
import vrajPathLogo from "../../images/vrajpath_logo.svg";
import { navLinks, company } from "../../content/companyProfile";
import "./Navbar.css";

const NavItem = ({ label, path, onClick }) => {
  if (path.includes("#")) {
    return (
      <HashLink smooth to={path} className="vp-navbar__link" onClick={onClick}>
        {label}
      </HashLink>
    );
  }
  return (
    <NavLink
      to={path}
      className={({ isActive }) =>
        `vp-navbar__link${isActive ? " vp-navbar__link--active" : ""}`
      }
      end={path === "/"}
      onClick={onClick}
    >
      {label}
    </NavLink>
  );
};

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = toggle ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [toggle]);

  useEffect(() => {
    setToggle(false);
  }, [location.pathname]);

  const closeMenu = () => setToggle(false);

  return (
    <header className={`vp-navbar${scrolled ? " vp-navbar--scrolled" : ""}`} id="app__navbar">
      <div className="vp-container vp-navbar__inner">
        <Link to="/" className="vp-navbar__brand" onClick={closeMenu}>
          <img src={vrajPathLogo} alt="" aria-hidden height={28} />
          <span className="vp-navbar__brand-text">{company.shortName}</span>
        </Link>

        <nav className="vp-navbar__links" aria-label="Main navigation">
          {navLinks.map(({ label, path }) => (
            <NavItem key={path} label={label} path={path} />
          ))}
        </nav>

        <div className="vp-navbar__actions">
          {/* <Link to="/contact" className="vp-navbar__text-link" onClick={closeMenu}>
            Contact
          </Link> */}
          <Link
            to="/enquiry"
            className="vp-btn vp-btn--primary vp-navbar__btn"
            onClick={closeMenu}
          >
            Get Started
          </Link>
          <button
            type="button"
            className="vp-navbar__menu-btn"
            aria-label="Open menu"
            aria-expanded={toggle}
            onClick={() => setToggle(true)}
          >
            <HiMenuAlt3 />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {toggle && (
          <motion.div
            className="vp-navbar__mobile"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="vp-navbar__mobile-panel"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
            >
              <div className="vp-navbar__mobile-header">
                <Link to="/" className="vp-navbar__brand" onClick={closeMenu}>
                  <span className="vp-navbar__brand-text">{company.shortName}</span>
                  <img src={vrajPathLogo} alt="" aria-hidden height={28} />
                </Link>
                <button type="button" className="vp-navbar__close" onClick={closeMenu} aria-label="Close">
                  <HiX />
                </button>
              </div>
              <nav className="vp-navbar__mobile-nav">
                {navLinks.map(({ label, path }) => (
                  <NavItem key={path} label={label} path={path} onClick={closeMenu} />
                ))}
                {/* <Link to="/contact" className="vp-navbar__link" onClick={closeMenu}>
                  Contact
                </Link> */}
              </nav>
              <div className="vp-navbar__mobile-actions">
                <Link to="/enquiry" className="vp-btn vp-btn--primary vp-navbar__btn" onClick={closeMenu}>
                  Get Started
                </Link>
              </div>
            </motion.div>
            <button type="button" className="vp-navbar__backdrop" onClick={closeMenu} aria-label="Close" />
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
